module.exports = __webpack_public_path__ + "img-dashboard/register/copy-gray.d0e24443.svg";